import './FacetsHeader.scss';
import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {changeFilterPersistence, changePendingState, changeSort, clearAllSelectedFilters} from '../duck/filter.actions';
import {useAreFiltersPersistent, useSelectedFilters, useSort} from '../duck/filter.hooks';
import {FacetValuesSortOrder, HibuFacetFilter} from '../facet.types';
import {Button} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {SortDropdown} from '../../common/sort-dropdown/sortDropdown';
import {Option} from '../../common/select/select';
import {Checkbox} from '../../common/checkbox/checkbox';
import {facetUtils} from '../facet.utils';
import {filterFacets} from '../facet.service';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {URL_RF_PARAM} from '../../search/const';

export const FacetsHeader = React.memo(() => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const selectedFilters: HibuFacetFilter = useSelectedFilters();
    const sort: FacetValuesSortOrder = useSort();
    const isPersistent: boolean = useAreFiltersPersistent();

    const sortOptions: Option[] = [
        {value: FacetValuesSortOrder.COUNT, label: t('facets.sortBy.' + FacetValuesSortOrder.COUNT)},
        {value: FacetValuesSortOrder.NAME, label: t('facets.sortBy.' + FacetValuesSortOrder.NAME)},
    ];

    const onDeleteFilters = () => {
        dispatch(changePendingState(true));
        dispatch(clearAllSelectedFilters());
        dispatch(filterFacets(navigate)); // trigger search (fetchFacets and searchDocuments)
    };

    const onChangeSort = (selectedOrder: FacetValuesSortOrder) => {
        dispatch(changeSort(selectedOrder));
    };

    const onTogglePersistFilter = useCallback(() => {
        const newValue = !isPersistent;
        dispatch(changeFilterPersistence(newValue));
        searchParams.set(URL_RF_PARAM, '' + !isPersistent);
        setSearchParams(searchParams, {replace: true});
    }, [dispatch, isPersistent, searchParams, setSearchParams]);

    return (
        <>
            <div id="facets-header">
                {facetUtils.hasAnySelectedFilter(selectedFilters) ? (
                    <Button className="facet-title clear-filter-button" onClick={onDeleteFilters}>
                        {t('facets.clearAll')}
                    </Button>
                ) : (
                    <span className="facet-title">{t('facets.title')}</span>
                )}
                <SortDropdown
                    id="facet-sort"
                    value={sortOptions.find((option) => option.value === sort)}
                    onChange={(selectedOption: Option) => onChangeSort(selectedOption.value)}
                    options={sortOptions}
                />
            </div>
            <div className={'facets-persist-filter'}>
                <Checkbox
                    value={isPersistent}
                    mayEdit={true}
                    labelKey={'settings.retainFilterAcrossSearches'}
                    onChange={() => onTogglePersistFilter()}
                />
            </div>
        </>
    );
});
